import { connect } from 'react-redux';
import NewsSingle from '../components/NewsSingleComponent';
import {
    fetchDataSingleNewsIfNeeded,
    fetchDataSingleProNews,
    fetchDataNewsMostReadIfNeeded,
    fetchDataRelatedNewsIfNeeded,
    setNotFound,
} from '../actions/NewsActions';

const mapStateToProps = (state) => {
    const dataNewsMostRead = state.news.dataNewsMostRead;
    const isFetchingByReducer = state.news.isFetching;
    const breakpoint = state.breakpointReducer;
    const dataRelatedNews = state.news.dataRelatedNews;
    const notFound = state.news.notFound;
    const userIsPro = !!state.profile.user.isPro;

    return {
        dataSingleNews: state.news.dataSingleNews,
        dataNewsMostRead,
        isFetching: isFetchingByReducer,
        breakpoint,
        dataRelatedNews,
        notFound,
        userIsPro,
    };
};
const mapDispatchToProps = (dispatch) => ({
    fetchDataSingleNewsIfNeeded: (slug) => {
        dispatch(fetchDataSingleNewsIfNeeded(slug));
    },
    fetchDataSingleProNews: (slug) => {
        dispatch(fetchDataSingleProNews(slug));
    },
    fetchDataNewsMostReadIfNeeded: () => {
        dispatch(fetchDataNewsMostReadIfNeeded());
    },
    fetchDataRelatedNewsIfNeeded: (tags, limitNews) => {
        dispatch(fetchDataRelatedNewsIfNeeded(tags, limitNews));
    },
    setNotFound: (notFound) => {
        dispatch(setNotFound(notFound));
    },
});
const NewsSingleContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsSingle);

export default NewsSingleContainer;
